import { Component, Input } from '@angular/core';
import { FiltersComponent } from 'src/app/common/filters.component';
import { Transport } from '../../service.model';

@Component({
	selector: 'app-services-list-filters',
	templateUrl: './services-list-filters.component.html',
	styleUrls: ['./services-list-filters.component.scss'],
})
export class ServicesListFiltersComponent extends FiltersComponent {
	@Input() transport;
	filters: Record<string, Transport[]> = {
		transport: [],
	};
	protected filtersDefinition = {
		transport: {
			type: 'string',
			isArray: false,
		},
	};
}
